/**
 * Formats a date range into a human-readable string.
 *
 * - Both dates present: `"startDate - endDate"`
 * - Only start: `"seit startDate"`
 * - Only end: `"bis endDate"`
 * - Neither: `null`
 */
function getDateRangeString(
  startDate: string | null | undefined,
  endDate?: string | null | undefined
): string | null {
  if (startDate && endDate) {
    return `${startDate} - ${endDate}`;
  } else if (startDate) {
    return `seit ${startDate}`;
  } else if (endDate) {
    return `bis ${endDate}`;
  } else {
    return null;
  }
}

export default getDateRangeString;
